import React from "react";
import { Link } from "react-router-dom";
import { LogoName } from "../../Utility/constants";
import "./AdminHeader.css"; // Import the CSS file for custom styles
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons"; // Import a profile icon

const ReceptionistHeader = () => {
  const isDisabled = true;
  const handleLogout = () => {
    // Clear user data from local storage
    localStorage.removeItem("userEmail");
    localStorage.removeItem("Role");
    localStorage.removeItem("userID");
    sessionStorage.removeItem("TeacherDashboardGreeting")
    sessionStorage.removeItem("dashboardGreeting")
    sessionStorage.removeItem("StudentDashboardGreeting")
    // Redirect to the login page or home page
    window.location.href = "/";
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container d-flex justify-content-between">
          <a
            className="navbar-brand"
            href="/manage-reception-dashboard"
            style={{ color: "white" }}
          >
            {LogoName}
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav me-auto">
              <>
                <li className="nav-item dropdown">
                  <Link
                    to="/manage-inquiry"
                    className="nav-link"
                    style={{ color: "white" }}
                  >
                    Manage Inquiry 
                  </Link>
                  <div
                    className="dropdown-menu bg-dark"
                    aria-labelledby="manageMastersDropdown"
                  ></div>
                </li>
              </>
            </ul>
          </div>
          <div className="d-flex align-items-center">
            {/* Profile icon */}
            <Link to="/student-profile" className="text-light me-3">
              <FontAwesomeIcon icon={faUserCircle} size="2x" />
            </Link>
            {/* Logout button */}
            <button className="btn btn-outline-light" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default ReceptionistHeader;
